import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import DisburseToInvestor from '../../container/borrower/facilitator-project/projectDetail/DisburseToInvestor';

const InvestorList = lazy(() => import('../../container/facilitator-investor/investorList'));
const InvestorUpdate = lazy(() => import('../../container/facilitator-investor/investorUpdate'));
const InvestorDetails = lazy(() => import('../../container/facilitator-investor/InvestorDetail/investorDetails'));

export default function InvestorRoute() {
  return (
    <Routes>
      <Route path="list" element={<InvestorList />} />
      <Route path="detail/:id" element={<InvestorDetails />} />
      <Route path="update/:id" element={<InvestorUpdate />} />
      <Route path="disburse" element={<DisburseToInvestor />} />
    </Routes>
  );
}
